import React from 'react';

import metrics from 'maps/metrics';
import { tableHeaders, withChangeMetric } from './constants';

import useMedia from 'hooks/useMedia';
import { getMenuItems } from 'components/data-containers/PlaylistTable/util/getMenuItems';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import Table from 'components/data-visualization/Table/Table';
import Row from 'components/data-visualization/Table/Row';
import Body from 'components/data-visualization/Table/Body';
import Cell from 'components/data-visualization/Table/Cell';
import DropdownTableHead from 'components/data-visualization/Table/DropdownHead';

const noop = (): void => {}; // eslint-disable-line @typescript-eslint/no-empty-function

const Wrapper: React.FC<{ children: any; title?: string }> = ({
  children,
  title,
}) =>
  title ? (
    <GenericComponent
      title={title}
      loading={true}
      success={false}
      showToolbarDropdown={false}
      isNarrowScreen
    >
      <AnimatedLoadingWrapper loading={true}>{children}</AnimatedLoadingWrapper>
    </GenericComponent>
  ) : (
    <>{children}</>
  );
const SkeletonLoader: React.FC<{ title?: string }> = (props) => {
  const { title } = props;

  const isLargeScreen = useMedia('(min-width: 62em)');

  return (
    <Wrapper title={title}>
      <Table>
        {isLargeScreen && (
          <DropdownTableHead
            headers={tableHeaders}
            setSortMetric={noop}
            setSortOrder={noop}
            changeSortMetric={noop}
            sortMetric={metrics['stream_count_this_week_to_date']}
            notSortable={null}
            sortOrder="desc"
            doubleLineMetric={true}
            hideVisually={null}
            withChangeMetric={withChangeMetric}
            predefinedMenuItems={getMenuItems(tableHeaders, false)}
            redesignedTable={true}
          />
        )}

        <Body>
          <TableLoader
            columnCount={3}
            rowComponent={Row}
            cellComponent={Cell}
          />
        </Body>
      </Table>
    </Wrapper>
  );
};

export default SkeletonLoader;
